<div class="raw main">
    <div class="col-12">
        <div class="col-6 right">
            <div class="signup">
                <h1>申請報名</h1>
    
                <h3>洽談日期與時段</h3>
                <div class="form">
                    <span>2020/03/03(二) 10:00~10:30</span>
                    <label class="change">變更洽談時段</label>
                </div>
    
                <h3>聯絡人資訊</h3>
                <div class="form">
                    <p class="msg">
                        1.若下方預帶非參加人姓名，請從下拉式選單選取更換，若選單無姓名，請選「新增參加人資訊」<br/><br/>
                        2.請勿使用共用業務帳號報名，以免核對上造成問題，若需更換參加者可於「我的預約」下拉更換或通知活動承辦人
                    </p>
    
                    <label>聯絡人</label>
                    <select class="unselect">
                        <option value="">新增聯絡人</option>
                    </select>
                    <span class="edit">修改聯絡人資訊</span>
                    
                    <label class="require">聯絡人中文姓名</label>
                    <input type="text" placeholder="請輸入聯絡人中文姓名"/>
    
                    <label class="require">聯絡人英文姓名</label>
                    <input type="text" placeholder="請輸入聯絡人英文姓名"/>
    
                    <label class="require">聯絡人 Email</label>
                    <input type="text" class="fullwidth" placeholder="請輸入聯絡人 Email"/>
    
                    <label class="require">聯絡人手機</label>
                    <input type="text" placeholder="請輸入聯絡人手機"/>
    
                    <label class="require">公司電話</label>
                    <div class="phone">
                        <input type="text" placeholder="區碼"/>
                        <input type="text" class="number" placeholder="電話"/>
                        <input type="text" placeholder="分機"/>
                    </div>
                    
                </div>
                
                <h3>公司資訊</h3>
                <div class="form">
    
                    <label class="require">主要產品(中文)</label>
                    <textarea></textarea>
                    <span class="count">40/500</span>
    
                    <label class="require">主要產品(英文)</label>
                    <textarea></textarea>
                    <span class="count">40/500</span>
    
                </div>
    
                <div class="role">
                    <input type="checkbox" id="c0"/>
                    <label for="c0">本人同意以下 2 項：</label>
                    <p>
                        1.  本人為個資當事人，聲明已詳閱外貿協會之「個人資料保護聲明」，就告知內容充分知悉及同意。<br/>
                        2.  每場次活動結束後，本公司同意配合填寫相關問卷，以提供意見供外貿協會據以增進日後辦理活動之品質。
                    </p>
                </div>
    
                <a routerLink="/member/signCheck">
                    <div class="btn">確認送出</div>
                </a>
                
            </div>
            
            <div class="sideCard">
                <div class="col-4 side">
                    <label>您正在報名⋯</label>
                    <h1>EXATI TECNOLOGIA E DESENVOLVIMENTO DE SISTEMAS LTDA</h1>
                    <div class="item">
                        <label>國別</label>
                        <p>巴西(南美)</p>
                    </div>
                    <div class="item">
                        <label>網站</label>
                        <p>www.exati.com</p>
                    </div>
                    <div class="item">
                        <label>營業項目</label>
                        <p>Importer, Manufactorer</p>
                    </div>
                    <div class="item">
                        <label>採購產品</label>
                        <div class="tags">
                            <span>LED Driver (Power Supply)</span>
                            <span>Electronic Components</span>
                            <span>PCB(OEM)</span>
                            <span>PCBA(OEM)</span>
                            <span>整燈</span>
                        </div>
                    </div>
                    <hr/>
                    <div class="relative">
                        <div class="title">
                            <label>所屬採購案</label>
                            <span>此活動尚可預約 10 次</span>
                        </div>
                        <h2>2020年「台北國際電腦展」線上採購洽談會</h2>
                        <p class="time">
                            <i class="icon icon-clock">&#xe80d;</i>2020/06/03 下午 2 時至下午 6 時
                        </p>
                        <p class="addr">
                            <i class="icon icon-web">&#xe805;</i>世貿一館 (110台北市信義區信義路五段5號) <span class="map"><i class="icon icon-map">&#xe804;</i>地圖</span>
                        </p>
    
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
